import type { FaireProductEntity } from "../../entity_types/product";

export const p_pp7h5p8925: FaireProductEntity = {
  token: "p_pp7h5p8925",
  type: "product",
  name: "Enamel Heart Charm Gold Plated Cubic Zirconia Chain Necklace",
  brandToken: "b_nex9pcmkzj",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/f9403e3db91be3e238174c8031d60a3ab0377a492f955cb6b09676c53ecb8dc1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c2c4565fc145c92140ad1d1fa63420ae340a6520bb177e61f0b4400530353b78.jpeg",
    "https://cdn.faire.com/fastly/8874083e29514b033cfb93038aba241a1a25afa099199c54f3530d0add097ef7.jpeg",
    "https://cdn.faire.com/fastly/3c755bffc2929ea6256e5c24f8f6251f42fc4f41fb28d46c180d1c3877008752.jpeg",
    "https://cdn.faire.com/fastly/9239d9eb09ca3f2cb8dae02b82eb7315e4913cb2ca5af6ea2e71e4a4a005b694.jpeg",
    "https://cdn.faire.com/fastly/91c744f87c4cea68d86c7d0185b8de281ee4e886334716f4c0e6e8c72e828398.jpeg",
  ],
  priceDollars: 9.01,
  description:
    "\nType: pendant necklace\nMaterial:Cubic Zirconia , stainless steel , Enamel，18K gold plated\nSize of pendant ： 0.57in\nLength of chain ： 400mm / 15.74in\nProcess: Vacuum electroplating and manual polishing\nSurface : High Polish\n\n★Made of high quality stainless steel，Lead-free，Harmless to Human Body.\n★Perfect jewelry gifts\n",
  tags: [],
  msrpDollars: 18.01,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:15.432Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
